<template>
  <div class="column is-full" v-if="isVisibleFromFilter">
    <div class="card mx-5" :data-id="reservation.requestId">
      <header class="card-header">
        <p class="card-header-title">
          {{ flightTypeLabel }}
          {{ reservation.flightNumber }}
        </p>
      </header>

      <div class="card-content">
        <table>
          <tbody>
            <tr>
              <th class="table-header">Route</th>
              <td>
                <ul>
                  <li
                    v-for="(flight, index) in reservation.flights"
                    :key="index"
                  >
                    <b>{{ formatDateLabel(flight.departureDate) }}:</b>
                    🌎 {{ flight.departureAirport.name }} → 🌎
                    {{ flight.arrivalAirport.name }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th class="table-header">
                {{ $t("transportThankYouPage.Airline") }}
              </th>
              <td>
                <ul>
                  <li
                    v-for="(flight, index) in reservation.flights"
                    :key="index"
                  >
                    {{ flight.airline ?? "-" }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <th class="table-header">
                {{ $t("transportThankYouPage.HoldLuggage") }}
              </th>
              <td>{{ reservation.holdLuggage ? "✅" : "❌" }}</td>
            </tr>
            <tr>
              <th class="table-header">
                {{ $t("transportThankYouPage.ChangesAllowed") }}
              </th>
              <td>{{ reservation.changesAllowed ? "✅" : "❌" }}</td>
            </tr>
            <tr>
              <th class="table-header">
                {{
                  $t("transportThankYouPage.Travelers", {
                    count: reservation.travellers?.length ?? 0
                  })
                }}
              </th>
              <td>
                <ul>
                  <li
                    v-for="(passenger, index) in reservation.travellers"
                    :key="index"
                  >
                    {{ passenger.firstName }} {{ passenger.lastName }}
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isNowHappening,
  isFutureReservation,
  getDateRangeForReservation
} from "@/helpers/reservation.helper.js";

export default {
  props: {
    reservation: Object,
    visibleItems: {
      type: String,
      default: "ALL"
    }
  },
  computed: {
    flightTypeLabel() {
      const flightCount = this.reservation.flights?.length ?? 0;
      if (flightCount === 1) {
        return this.$t("ReservationForm.oneWay");
      } else if (flightCount === 2) {
        return this.$t("ReservationForm.roundTrip");
      } else {
        return this.$t("ReservationForm.multiLeg");
      }
    },
    isVisibleFromFilter() {
      let filter = this.visibleItems;
      switch (filter) {
        case "FUTURE":
          return isFutureReservation(this.reservation, "transport");
        case "CURRENT":
          return isNowHappening(this.reservation, "transport");
        default:
          return true;
      }
    },
    reservationDateRange() {
      return getDateRangeForReservation(this.reservation, "transport");
    }
  }
};
</script>

<style scoped>
.table-header {
  padding-right: 10px;
}
</style>
